/* eslint-disable no-secrets/no-secrets */
import React, { useCallback, useEffect } from 'react';
import _ from 'lodash';
import { WizardPage, wizardProps } from '@xengage/gw-portals-wizard-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { PremierConstants } from 'premier-constant-service';
import { useUpdateSubmissionServices, validationUtil } from 'premier-capability-hooks';
import { withRouter } from 'react-router-dom';

import { AdditionalInterestComponent } from "premier-capability-policyjob-react";
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import metadata from './MarPlePage.metadata.json5';

import RiskInformationComponent from "../../components/MarinePleasurecraft/RiskInformation/RiskInformationComponent";
import SkipFishCharterSuppleComponent from "../../components/MarinePleasurecraft/SkipFishCharterSupple/SkipFishCharterSuppleComponent";
import CompanyNameAuditComponent from "../../components/MarinePleasurecraft/CompanyNameAudit/CompanyNameAuditComponent";

function MarPlePage(props) {

    const { wizardData: submissionVM, updateWizardData } = props;
    const { updateSubmission } = useUpdateSubmissionServices();
    const { lineName } = PremierConstants;

    const {
        onValidate,
        initialValidation
    } = useValidation('ArchitectEngineersPage');


    useEffect(() => {

    }, []);

    const onNext = useCallback(
        async () => {
            const productCode = _.get(submissionVM.value, 'baseData.productCode');
            // eslint-disable-next-line security/detect-object-injection
            const lobLineName = productCode ? lineName[productCode] : '';
            const response = await updateSubmission(lobLineName, 'MarPlePage', submissionVM);

            submissionVM.value = response;

            return submissionVM;
        },
        [lineName, submissionVM, updateSubmission]
    );

    const onSave = useCallback(
        async () => {
            const subVMCopy = _.clone(submissionVM)
            const productCode = _.get(subVMCopy.value, 'baseData.productCode');

            validationUtil.unSetIsValidationReqFlag(subVMCopy.lobData.recMarLine.coverables.marinePleasurecraft.value, ' ')

            const lobLineName = productCode ? lineName[productCode] : '';
            await updateSubmission(lobLineName, 'MarPlePage', subVMCopy);
                            
            return submissionVM;
        },
        [lineName, submissionVM, updateSubmission]
    );

    const overrideProps = {
        RiskInformationComponent: {
            submissionVM,
            updateWizardData,
            pathUpdated: "lobData.recMarLine.coverables.marinePleasurecraft.riskInformation"
        },
        SkipFishCharterSuppleComponent: {
            submissionVM,
            updateWizardData,
            pathUpdated: "lobData.recMarLine.coverables.marinePleasurecraft.skipFishCharterSupple",
            visible: !_.isUndefined(submissionVM.value.lobData.recMarLine.coverables.marinePleasurecraft.riskInformation.isthiuseforguifiscchaFie)
                && submissionVM.value.lobData.recMarLine.coverables.marinePleasurecraft.riskInformation.isthiuseforguifiscchaFie
        },
        CompanyNameAuditComponent: {
            submissionVM,
            updateWizardData,
            pathUpdated: "lobData.recMarLine.coverables.marinePleasurecraft.companyNameAudit",
            visible: !_.isUndefined(_.find(submissionVM.baseData.account_Ext.accountContacts_Ext.value, (actlct) => actlct.subtype === 'Company')),
        }
    };

    const resolvers = {
        resolveCallbackMap: {
            onValidate
        },
        resolveComponentMap: {
            RiskInformationComponent,
            SkipFishCharterSuppleComponent,
            CompanyNameAuditComponent,
            additionalInterestComponent: AdditionalInterestComponent
        }
    };

    const readValue = useCallback(
        (id, path) => readViewModelValue(metadata.pageContent, submissionVM, id, path, overrideProps),
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [metadata.pageContent, submissionVM, overrideProps]
    );


    const isDisableNext = () => !submissionVM.lobData.recMarLine.coverables.marinePleasurecraft.aspects.subtreeValid

    return (
        <WizardPage onNext={onNext} onSave={onSave} skipWhen={initialValidation} disableNext={isDisableNext()}>
            <ViewModelForm
                uiProps={metadata.pageContent}
                model={submissionVM}
                onModelChange={updateWizardData}
                overrideProps={overrideProps}
                onValidationChange={onValidate}
                resolveValue={readValue}
                callbackMap={resolvers.resolveCallbackMap}
                componentMap={resolvers.resolveComponentMap}
                classNameMap={resolvers.resolveClassNameMap}
            />
        </WizardPage>
    );
}

MarPlePage.propTypes = wizardProps;
export default withRouter(MarPlePage);
